import React, { useEffect, useReducer, useState } from 'react'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/Components/ui/table'
import Constant from '@/utils/Constant'
import { Checkbox } from '@/Components/ui/checkbox'
import NoDataFound from '@/Components/Common/NoDataFound'
import { useSidebar } from '@/Components/ui/sidebar'
import Constent from '@/utils/constent'
import WorkAllocationService from '@/Service/WorkAllocationService'
import SearchableDropdown from '@/Components/Common/SearchableDropdown'
import { useNavigate } from 'react-router-dom'

const WorkAllocationTable = ({ data, columns, getWorkAllocation, chartLockIssue, parentEvent, parentUpdateEvent }) => {
    const navigate = useNavigate()
    useEffect(() => {
        if (data) {
            updateEvent({ paginatedData: data })
        }
    }, [data])
    const url = new URLSearchParams(location.search)

    const { open } = useSidebar()
    const [event, updateEvent] = useReducer(
        (prev, next) => {
            return { ...prev, ...next }
        },
        {
            paginatedData: data,
            searchFilter: {
                limit: url.get('limit') && url.get('limit') != 'undefined' ? url.get('limit') : Constent.PAGINATION_SIZE,
                page: 1,
            },
        }
    )

    const handlePriorityChange = async (val, row) => {
        let priority = ''
        if (val) {
            priority = 'High'
        }
        try {
            const priorityStatus = await WorkAllocationService.updatePriority(priority, row.name)
            if (priorityStatus.data.success) {
                getWorkAllocation()
            }
        } catch (err) {
            console.log('errpr', err)
        }
    }
    const handleChartLockIssue = async (val, row) => {
        try {
            const chartLockIssue = await WorkAllocationService.updateChartLockIssue(val, row.name)
            if (chartLockIssue.data.success) {
                getWorkAllocation()
            }
        } catch (err) {
            console.log('errpr', err)
        }
    }

    const handleCheckboxChange = (val, row) => {
        try {
            if (val) {
                let deleteIdArray = []
                if (!parentEvent.isChecked?.includes(row.name)) {
                    deleteIdArray = [...parentEvent.isChecked, row.name]
                    parentUpdateEvent({ isChecked: deleteIdArray })
                }
                if (deleteIdArray.length === event.paginatedData.length) {
                    parentUpdateEvent({ checkedAll: true })
                } else {
                    parentUpdateEvent({ checkedAll: false })
                }
            } else {
                parentUpdateEvent({ checkedAll: false })
                if (parentEvent.isChecked?.includes(row.name)) {
                    let newdeleteId = parentEvent.isChecked.filter((item) => item !== row.name)
                    parentUpdateEvent({ isChecked: newdeleteId })
                }
            }
        } catch (err) {
            console.log(err)
        }
    }

    const handleAllChange = (val, rows) => {
        console.log('first', val, rows)
        parentUpdateEvent({ checkedAll: val })

        if (val) {
            rows.map((row, index) => {
                if (!parentEvent.isChecked.includes(row.name)) {
                    parentEvent.isChecked.push(row.name)
                    console.log('test all ', parentEvent.isChecked)
                    parentUpdateEvent({ isChecked: parentEvent.isChecked })
                }
            })
        } else {
            parentUpdateEvent({ isChecked: [] })
        }
    }

    const handleClick = (val) => {
        navigate('/work-allocation/' + val)
    }

    const handleCheckboxClick = (event) => {
        console.log('innclick')
        event.stopPropagation()
    }

    return (
        <div>
            <div className=" w-full overflow-auto overflow-card-scroll h-[calc(100vh-250px)] ">
                <Table className="mt-2" style={{ width: event.paginatedData.length === 0 ? '100%' : columns.length > 15 ? '200%' : '150%' }}>
                    <TableHeader className="sticky top-0 z-30">
                        <TableRow className="shadow-md h-12  py-6">
                            <TableHead key="Sr.No" className=" text-left text-[13px] font-bold bg-gray-100 z-30">
                                <Checkbox checked={parentEvent.checkedAll} onCheckedChange={(val) => handleAllChange(val, event.paginatedData)} />
                            </TableHead>
                            {columns.map((value, i) => (
                                <TableHead key={value.accessor_key} className=" text-left text-[13px] font-bold bg-gray-100 z-30">
                                    {value.header}
                                </TableHead>
                            ))}
                        </TableRow>
                    </TableHeader>
                    <TableBody className="z-5">
                        {event.paginatedData.length == 0 ? (
                            <TableRow>
                                <TableCell colspan={'100%'} className="h-20">
                                    {<NoDataFound />}
                                </TableCell>
                            </TableRow>
                        ) : (
                            <>
                                {event.paginatedData.map((row, currentIndex) => (
                                    <TableRow
                                        key={currentIndex + 1 + (Constant.PAGINATION_SIZE * event.currentPage - Constant.PAGINATION_SIZE)}
                                        className="shadow-md py-2 h-12 cursor-pointer"
                                        onClick={() => handleClick(row.name)}
                                    >
                                        <TableCell>
                                            {parentEvent.checkedAll ? (
                                                <Checkbox
                                                    onCheckedChange={(val) => handleCheckboxChange(val, row)}
                                                    checked={parentEvent.checkedAll}
                                                />
                                            ) : (
                                                <Checkbox
                                                    onClick={(event) => handleCheckboxClick(event)}
                                                    onCheckedChange={(val) => handleCheckboxChange(val, row)}
                                                    checked={parentEvent.isChecked?.includes(row.name)}
                                                />
                                            )}
                                        </TableCell>

                                        {columns.map((value, i) => (
                                            <TableCell className=" text-[13px] text-left py-2">
                                                {value.accessorKey in row ? (
                                                    value.accessorKey == 'priority' ? (
                                                        <Checkbox
                                                            onCheckedChange={(event) => handlePriorityChange(event, row)}
                                                            checked={row.priority == 'High' ? true : false}
                                                            onClick={(event) => handleCheckboxClick(event)}
                                                        />
                                                    ) : value.accessorKey == 'chart_lock_issue' ? (
                                                        <>
                                                            <SearchableDropdown
                                                                options={chartLockIssue}
                                                                selectedVal={row.chart_lock_issue}
                                                                handleChange={(val) => {
                                                                    handleChartLockIssue(val, row)
                                                                }}
                                                                label="chart_lock_issue"
                                                                placeholder="Chart Lock Issue"
                                                                onClick={(event) => handleCheckboxClick(event)}
                                                            />
                                                        </>
                                                    ) : (
                                                        row[value.accessorKey]
                                                    )
                                                ) : (
                                                    ''
                                                )}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </>
                        )}
                    </TableBody>
                </Table>
            </div>
        </div>
    )
}

export default WorkAllocationTable
